import { combineReducers } from 'redux'
import emailConfigurationReducer from './configuration'
import emailSignatureReducer from './signature'

export const EmailSettingsReducer = combineReducers({
  configuration: emailConfigurationReducer,
  signature: emailSignatureReducer,
})
